<div class="login">
	<div class="loginColumns animated fadeInRight gray-medium-bg b-r-lg">
		<div class="text-center">
			<div class="center-orientation">
				<img class="apm-logo" src="assets/images/SMG_colorfull.png">
			</div>
			<h2 class="font-bold">LOGIN</h2>
		</div>
		<div *ngIf="!recuperar.active">
		<form class="m-t" role="form" [formGroup]="form" (ngSubmit)="login()">
			<div class="form-group m-b-sm">
				
				<ng-select id="entidade" class="ng-select-alternative" [items]="entidades" bindLabel="label" bindValue="id" 
					formControlName="entidade" (change)="saveQueryParams()" placeholder="Selecionar o Ente Federativo">
				</ng-select>
				
			</div>
			<div class="form-group m-b-sm">
				<input type="text" name="usuario" class="form-control"
					placeholder="CPF" required="" maxlength="11"
					formControlName="usuario" />
			</div>
			<div class="form-group m-b">
				<input type="password" name="senha" class="form-control"
					placeholder="Senha" required
					formControlName="senha" />
			</div>
			<div *ngIf="invalido" class="form-group m-b m-t invalido-p-l">
				<p class="text-danger">{{ invalido }}</p>
			</div>
			<button type="submit" class="btn btn-primary block full-width m-b">Entrar</button>
			<a href="#" (click)="recuperarActive($event)"><small>Esqueci minha senha</small></a>
			<!-- <a [href]="urlRecuperacaoAntiga()"><small>Esqueci minha senha</small></a> -->
		</form>
		<hr />
		<div class="text-center">Você também pode se autenticar usando os botões abaixo:</div>
			<button type="button"
				class="btn btn-outline btn-success full-width mt-2" (click)="loginSoe()">
				<img src="assets/images/marca_SOE.png" class="marca-soe" /> <br />
				<small><i>Identifique-se para entrar</i></small>
			</button>
		</div>

		<form *ngIf="recuperar.active" class="m-t" (ngSubmit)="recuperarSenha()">
			<h3 class="text-center">Recuperar Senha</h3>
			<div class="form-group m-b">
				<input type="text" name="cpf" class="form-control" placeholder="CPF" required  maxlength="11" [(ngModel)]="recuperar.cpf"/>
			</div>
			<button type="submit" class="btn btn-primary block full-width m-b">Recuperar Senha</button>
			<a href="#" (click)="recuperarActive($event)"><small>Voltar para o login</small></a>
			<hr />
		</form>

		<div class="text-right mt-3">
			<img src="assets/images/logo_procergs.gif" />&nbsp; <small>&copy;{{date.getFullYear()}}</small>
		</div>
	</div>
</div>

<app-loading [loader]="isLoading"></app-loading>